import React from 'react'
import { PMPBodySectionItems } from './styledComponent'
import { PRESCRIPTION_COLORS_MAP } from '../../../inputComponents/common/color-utils'
import { getCasedHeadingTextBasedOnStyleOverrides } from './util'

export default function PrintableSuggestedTherapies({
  suggestedTherapiesRef,
  debug,
  selectedTherapies,
  debugHighlightStates,
  styleOverrides,
}) {
  return (
    <PMPBodySectionItems
      ref={suggestedTherapiesRef}
      debug={debug}
      debugColor={PRESCRIPTION_COLORS_MAP.suggestedTherapy.color}
      debugHighlight={debugHighlightStates?.suggestedTherapies}
    >
      <span
        style={{
          fontSize: styleOverrides?.headingFontSize
            ? `${styleOverrides?.headingFontSize}px`
            : 'inherit',
          color: styleOverrides?.headingColor || 'inherit',
        }}
      >
        <strong>
          {getCasedHeadingTextBasedOnStyleOverrides({
            headingText: 'Suggested Therapies',
            styleOverrides,
          })}
        </strong>
      </span>
      <div
        style={{
          fontSize: styleOverrides?.fontSizePixels
            ? `${styleOverrides?.fontSizePixels}px`
            : 'inherit',
          color: styleOverrides?.color || 'inherit',
        }}
      >
        {selectedTherapies?.map((item) => item?.label)?.join(', ')}
      </div>
    </PMPBodySectionItems>
  )
}
